module.exports = __webpack_public_path__ + "static/media/img-keelo-product-4.ea8ac7cc.png";